export default [
  {id: 1, name: '教师工作计划'},
  {id: 2, name: '备课组工作计划'},
  {id: 3, name: '教研组工作计划'},
  {id: 4, name: '备课组集体活动计划'},
  {id: 5, name: '教研组公开课活动计划'},
  {id: 7, name: '班主任德育计划'},
  {id: 8, name: '班级基本情况表'},
  {id: 6, name: '其他'},
]



// WEBPACK FOOTER //
// ./src/constants/plan_types.js